import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { AppShellService } from '../../core/services/app-shell.service';
import { FeatureFlagsService } from '../../core/services/feature-flags.service';
import { LayoutPreferenceService } from '../../core/services/layout-preference.service';
import { UiDrawerComponent } from '../../ui/drawer/ui-drawer.component';
import { UiSkeletonComponent } from '../../ui/skeleton/ui-skeleton.component';
import { UiSidebarComponent } from '../../ui/sidebar/ui-sidebar.component';
import { UiTopbarComponent } from '../../ui/topbar/ui-topbar.component';
import { UiNavSearchComponent } from '../../ui/nav-search/ui-nav-search.component';
import { UiUserMenuComponent } from '../../ui/user-menu/ui-user-menu.component';
import { UiThemeToggleComponent } from '../../ui/theme-toggle/ui-theme-toggle.component';
import { UiBetaBannerComponent } from '../../ui/beta-banner/ui-beta-banner.component';
import { UiAppFooterComponent } from '../../ui/app-footer/ui-app-footer.component';
import { UiBreadcrumbItem } from '../../ui/breadcrumbs/ui-breadcrumbs.component';

@Component({
  selector: 'veitros-modern-shell',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    UiDrawerComponent,
    UiSkeletonComponent,
    UiSidebarComponent,
    UiTopbarComponent,
    UiNavSearchComponent,
    UiUserMenuComponent,
    UiThemeToggleComponent,
    UiBetaBannerComponent,
    UiAppFooterComponent,
  ],
  templateUrl: './modern-shell.component.html',
  styleUrl: './modern-shell.component.scss',
})
export class ModernShellComponent {
  shell = inject(AppShellService);
  featureFlags = inject(FeatureFlagsService);
  layoutPref = inject(LayoutPreferenceService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  breadcrumbs: UiBreadcrumbItem[] = [];
  routerUrl = '';

  get showBetaBanner(): boolean {
    return this.featureFlags.isEnabled('ui.layout_v2');
  }

  constructor() {
    this.routerUrl = this.router.url;

    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((event) => {
      const url = (event as NavigationEnd).urlAfterRedirects;
      this.routerUrl = url;
      this.breadcrumbs = this.buildBreadcrumbs();
    });

    this.breadcrumbs = this.buildBreadcrumbs();
  }

  revertToClassic(): void {
    this.layoutPref.disable();
    window.location.reload();
  }

  closeDrawer(): void {
    this.shell.drawerVisible = false;
  }

  private buildBreadcrumbs(): UiBreadcrumbItem[] {
    const crumbs: UiBreadcrumbItem[] = [];
    let current: ActivatedRoute | null = this.route.root;
    while (current) {
      const data = current.snapshot.data;
      if (data['breadcrumb']) crumbs.push({ label: data['breadcrumb'] });
      current = current.firstChild;
    }
    return crumbs;
  }
}
